import React, { Dispatch, FC, SetStateAction } from 'react';
import { BankAccount } from '../../../../interfaces';
import { Button, Modal } from '../../../components';
import { detectBank, formatCardNumber } from 'scripts';
import { Link } from 'react-router-dom';
import { PATH } from 'data/30pay.path';

interface Props {
    open: boolean;
    setOpen: Dispatch<SetStateAction<boolean>>;
    cardNumbers: Omit<BankAccount, 'iBan'>[];
    onSelect: (cardNumber: Omit<BankAccount, 'iBan'>) => void;
}

export const CardNumberSelectionModal: FC<Props> = ({ open, setOpen, cardNumbers, onSelect }) => {
    return (
        <Modal open={open} setOpen={setOpen} title={'انتخاب شماره کارت'}>
            <ul>
                {cardNumbers.length !== 0 ? (
                    cardNumbers.map((cardNumber) => (
                        <li
                            onClick={() => onSelect(cardNumber)}
                            key={cardNumber.id}
                            className={
                                'h-12 hover:bg-background rounded-lg px-3 flex items-center justify-between clickable'
                            }
                        >
                            <div className={'flex items-center gap-4'}>
                                <img
                                    src={detectBank(cardNumber.cardNumber)?.bank_logo}
                                    alt={'Bank'}
                                    className={'w-6 h-6'}
                                />
                                <span className={'text-base font-bold text-darkPurple-100'}>
                                    {cardNumber.bank ? cardNumber.bank.name : 'نامشخص'}
                                </span>
                            </div>
                            <span className={'font-medium text-base text-darkPurple-100'}>
                                {formatCardNumber(cardNumber.cardNumber)}
                            </span>
                        </li>
                    ))
                ) : (
                    <div className="flex flex-col gap-6 items-center justify-center pt-2">
                        <h6 className="text-base font-medium text-darkPurple-80">تا کنون کارتی ثبت نشده است</h6>
                        <Link className="w-full" to={PATH.cards}>
                            <Button className="w-full" type="primary">
                                ثبت کارت جدید
                            </Button>
                        </Link>
                    </div>
                )}
            </ul>
        </Modal>
    );
};
